import controller from './data-connectors.controller';

const template = require('./data-connectors.html');

export default {
    controller,
    template
};
